

<template>
  <!-- <a-table :pagination='false' :loading='CodeLoading' bordered rowKey='product_code' :columns='columns' :data-source='data'>
  </a-table> -->
  <table class="tab" v-if="data!=''">
  <tr class="f1">
    <th>自定义字段</th>
    <th>字段值</th>
  </tr>
  <tr v-for="(item,i) in data"
  :key=i
  class="f2"
  >
  <td class="t1">{{item.key}}</td>
  <td>{{item.value}}</td>
  </tr>
</table>
<table v-else></table>
</template>

<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { CodeScanningDetails } from "@/api/member";
import { iscode } from "@/utils/app";
import store from "@/store";
// 初始化默认筛选项数值
let defSearch = {
  list: "",
};
export default {
  name: "codeList",
  components: {},
  props: {
    list: {
      type: Array,
    },
  },
  setup(props, { emit }) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    let columns = [];
    // 列表数据和列头配置
    let data = ref([...props.list]);
    data.value.forEach((y, item) => {
      console.log(y);
      for (let i in y) {
        // console.log(i);
        // columns.push({
        //   title: i,
        //   dataIndex: i,
        //   key: i,
        // });
      }
    }); 
    console.log(columns);
    const state = reactive({
      CodeLoading: false,
      total: 0,
    });
    //收集信息

    const $router = inject("$router");
    const $Modal = inject("$Modal");
    const _lodash = inject("_lodash");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      // initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      // initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      // initData(search.value);
    };
    onMounted(() => {
      console.log(props.list);
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
    };
  },
};
</script>
<style lang="less" scoped>
.tab{
  width: 100%;
    border:1px solid #f0f0f0;
  // display: flex;

}
.tab .f1{
  background-color: #f5f5f8;
    width: 100%;
      height: 3.125vw;
}
.tab .f1 th{
  width: 50%;
  border:1px solid #f0f0f0;
  text-align:center;
}
.tab .f2{
     height: 3.125vw;
  border:1px solid #f0f0f0;
    text-align:center;
}
.tab .f2 .t1{
    border-right:1px solid #f0f0f0;
}
</style>